// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { extendedProps, notifyStyles } from "@bg/App/Components/Notify/Notify";
import { fontConfig } from "@bg/XDL/PreStyle/typography";
import getColor from "@insite/mobius/utilities/getColor";
import { css } from "styled-components";

extendedProps.icons = { success: "Check", danger: "Clear", info: "Info", warning: "Alert" };

notifyStyles.notifyContainerOverrides = css`
    display: flex;
    width: 100%;
    max-width: 100%;
    background: ${getColor("text.main")};
    box-shadow: 0 0 25px 0 rgba(79, 79, 119, 0.18);
    opacity: 0.8;
    padding: 10px;
    font-size: ${fontConfig.fontSize.small}px;
    line-height: ${fontConfig.lineHeight.singleLine};
    border-top: unset;
    color: ${getColor("common.white")};
`;

notifyStyles.iconContainerOverrides = css`
    display: flex;
    align-items: center;
    justify-content: center;
    width: 20px;
    height: 20px;
    margin: auto 10px auto 0;
`;

notifyStyles.notifyTitleOverrides = css`
    margin-right: 8px;
    display: flex;
    flex-direction: row;
    align-items: center;
    font-weight: ${fontConfig.weight.bold};
    width: 100%;
    && {
        a,
        a *,
        button,
        button * {
            color: ${getColor("common.white")};
            text-decoration: underline;
        }
    }
`;

notifyStyles.notifyBodyOverrides = css`
    display: flex;
    flex-direction: row;
    align-items: center;
    word-break: break-word;
    && {
        a,
        a *,
        button,
        button * {
            color: ${getColor("common.white")};
            text-decoration: underline;
        }
    }
`;

notifyStyles.closeButtonContainerOverrides = css`
    display: flex;
    flex-direction: row;
    align-items: center;
    cursor: pointer;
    position: relative;
`;

notifyStyles.closeButtonIconProps = {
    src: "Clear",
    size: 6,
    color: "common.white",
    css: css`
        margin: 4px 10px;
        opacity: 0.65;
        position: absolute;
        top: -6px;
        right: -12px;
    `,
};
